import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { FormTemplate } from '@/types/api/form'
import { FormFieldType } from '@/types/enums'

import { FieldTypePalette } from './FieldTypePalette'
import type { FieldTypeConfig } from './fieldTypeConfig'

interface FieldTypePickerSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  items: FieldTypeConfig[]
  onAddField: (type: FormFieldType) => void
  templates?: FormTemplate[]
  templatesLoading: boolean
  templatesError: boolean
  onApplyTemplate: (template: FormTemplate) => void
  onDeleteTemplate?: (template: FormTemplate) => void
  canDeleteTemplate?: (template: FormTemplate) => boolean
}

export function FieldTypePickerSheet({
  open,
  onOpenChange,
  items,
  onAddField,
  templates,
  templatesLoading,
  templatesError,
  onApplyTemplate,
  onDeleteTemplate,
  canDeleteTemplate,
}: FieldTypePickerSheetProps) {
  const handleAddField = (type: FormFieldType) => {
    onAddField(type)
    onOpenChange(false)
  }

  const handleApplyTemplate = (template: FormTemplate) => {
    onApplyTemplate(template)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="fixed bottom-0 left-0 top-auto grid h-[min(84dvh,48rem)] w-full max-w-none translate-x-0 translate-y-0 grid-rows-[auto_minmax(0,1fr)] gap-0 overflow-hidden rounded-b-none rounded-t-2xl border-x-0 border-b-0 p-0 md:bottom-auto md:left-1/2 md:top-1/2 md:h-[min(80dvh,48rem)] md:w-[min(34rem,calc(100vw-2rem))] md:max-w-lg md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-xl md:border md:p-0">
        <DialogHeader className="border-b border-border px-5 py-4 text-left">
          <DialogTitle>Add a field</DialogTitle>
          <DialogDescription>Choose a field type or start from a template.</DialogDescription>
        </DialogHeader>
        <div className="min-h-0 overflow-hidden pb-[env(safe-area-inset-bottom)]">
          <FieldTypePalette
            items={items}
            onAddField={handleAddField}
            templates={templates}
            templatesLoading={templatesLoading}
            templatesError={templatesError}
            onApplyTemplate={handleApplyTemplate}
            onDeleteTemplate={onDeleteTemplate}
            canDeleteTemplate={canDeleteTemplate}
            draggable={false}
            showHeader={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
